import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { GAMES_INFO_POPUP_ID } from './constants';
import { GamesInfoPopup } from './GamesInfoPopup';

export const showGameInfoAction = (code, navigationDirection, location, onClose) => {
    const { showBackButton, hideButtons, gameLaunchType, showFavoriteIcon, queryString } = location.state || {};

    return addPopupAction({
        id: GAMES_INFO_POPUP_ID,
        component: GamesInfoPopup,
        layer: LAYER.GAMES_INFO,
        addFirst: navigationDirection === -1,
        onClose,
        data: {
            code,
            hideButtons,
            queryString,
            showBackButton,
            gameLaunchType,
            showFavoriteIcon,
            navigationDirection
        }
    });
};
